import React, {PropTypes} from 'react'
import {Modal, Button} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import {Link} from 'react-router'
import './BreederBox.css'
import showToastr from '../../../../utils/showToastr'

class BreederBox extends React.Component {
  constructor (props) {
    super(props)
    this.save = this.save.bind(this)
  }

  save () {
    Actions.horseSetBreeder({horse_id: this.props.horse.id}).then((res) => {
      showToastr('success', 'ثبت شد')
      Actions.horseInfo(this.props.horse.key)
      Actions.userInfo()
      this.props.toggler(false)
      typeof (this.props.afterSave) === 'function' && this.props.afterSave()
    })
  }

  render () {
    const {toggler, isVisible} = this.props
    const hider = () => {
      toggler(false)
    }
    return (
      <Modal show={isVisible} onHide={hider} bsSize="sm" aria-labelledby="contained-modal-title-sm">
        <Modal.Header>
          <Modal.Title id="contained-modal-title-sm">ثبت پرورش دهنده</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            پرورش دهنده شخصی است که اسب را تولید کرده است.
            <br />
            بدینوسیله تأیید می‌کنید که شما
            «<b>{this.props.horse.breeder.name}</b>»
            پرورش دهنده
            «<b>{this.props.horse.name}</b>»
           می‌باشید، و با <Link to="/page/terms-of-service">قوانین مربوطه</Link> موافق هستید.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={hider}>انصراف</Button>
          <Button onClick={this.save} bsStyle="primary">تأیید</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

BreederBox.propTypes = {
  toggler: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  horse: PropTypes.object.isRequired,
  afterSave: PropTypes.func
}

export default BreederBox



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseBreederOwner/BreederBox/BreederBox.js